import {
  DatagridConfigurable,
  Pagination,
  ReferenceManyField,
  TabbedForm,
  TabbedFormViewProps,
  TextField,
  useCanAccess,
  useGetRecordId,
} from 'react-admin';
import { ShopScanResource } from '../../../Entities/ShopScan';
import TzDateField from '../../../Components/TzDate/TzDateField';
import { ReactElement } from 'react';
import {
  getShopScanMappingErrorPath,
  getShopScanMappingErrorRowSx,
  SHOP_SCAN_STATUS_FLAGS,
} from '../../Scan/utils';
import ScanButton from '../../../Components/ScanButton/ScanButton';
import BitmaskTagsField from '../../../Components/BitmaskTagsField/BitmaskTagsField';

export default function ScannerTab(props: TabbedFormViewProps): ReactElement {
  const merchantId = useGetRecordId();
  const scanAccess = useCanAccess({ action: 'list', resource: 'scans' });
  const canListScans = scanAccess.canAccess ?? false;

  return (
    <TabbedForm.Tab label="Scanner" {...props}>
      <ScanButton label="Run Scan" key="run" size="medium" merchantId={merchantId} />
      <ReferenceManyField<ShopScanResource>
        queryOptions={{ meta: { prefetch: canListScans ? ['scan'] : [] } }}
        reference="shop_scans"
        sort={{ field: 'start_date', order: 'DESC' }}
        target="merchant.id"
        pagination={<Pagination />}
      >
        <DatagridConfigurable
          bulkActionButtons={false}
          rowClick={(_id, _resource, record) =>
            getShopScanMappingErrorPath(record as ShopScanResource, merchantId)
          }
          rowSx={(record) => getShopScanMappingErrorRowSx(record as ShopScanResource)}
        >
          {canListScans && <TextField label="Scan ID" source="relationships.scan.data.id" />}
          <BitmaskTagsField
            label="Status"
            source="attributes.status"
            flags={SHOP_SCAN_STATUS_FLAGS}
          />
          <TzDateField
            serverTimezone="UTC"
            label="Start Date"
            showTime
            source="attributes.start_date"
          />
          <TzDateField
            serverTimezone="UTC"
            label="End Date"
            showTime
            source="attributes.end_date"
          />
          <TextField label="Total Offers" source="attributes.total_offers" />
          <TextField label="New Offers" source="attributes.new_offers" />
          <TextField label="Recovered Offers" source="attributes.recovered_offers" />
          <TextField label="Removed Offers" source="attributes.removed_offers" />
          <TextField label="Updated Offers" source="attributes.updated_offers" />
          <TextField label="Duplicate Offers" source="attributes.duplicate_offers" />
          <TextField label="Unchanged Offers" source="attributes.unchanged_offers" />
        </DatagridConfigurable>
      </ReferenceManyField>
    </TabbedForm.Tab>
  );
}
